const HIGHER_THAN_MODAL_Z_INDEX = 10001;

export default HIGHER_THAN_MODAL_Z_INDEX;
